export default __webpack_public_path__ + "static/media/mobile-icon.6f89de62.svg";